import Loadable from "app/components/Loadable";
import { lazy } from "react";

const DailyPlanList = Loadable(lazy(() => import("./DailyPlanList")));
const DailyPlanForm = Loadable(lazy(() => import("./DailyPlanForm")));

const dailyPlanRoutes = [
  {
    path: "/dailyPlan/DailyPlanList",
    element: <DailyPlanList />,
  },
  {
    path: "/dailyPlan/DailyPlanForm",
    element: <DailyPlanForm />,
  },
  {
    path: "/dailyPlan/DailyPlanForm/:dailyPlanId",
    element: <DailyPlanForm />,
  },
];

export default dailyPlanRoutes;
